import { AuditServiceSchemaTypes } from "@bfc-software/api-schemas";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";
import {
  aaaTokenOnly,
  useAuthenticatedApi,
  useAuthenticatedFetchClient,
} from "@bfc-software/bfc-web-ui/lib/authenticated-api";

type Paths = AuditServiceSchemaTypes.paths;

const spec = () => ({
  baseUrl: getEnv().auditServiceBase,
  select: aaaTokenOnly,
});

export const useAuditApi = () => useAuthenticatedApi<Paths>(spec());

/** Stable client for imperative use (callbacks, queryFn). Rebuilt only when the token changes. */
export const useAuditFetchClient = () =>
  useAuthenticatedFetchClient<Paths>(spec());
